import { render } from "./complaintTracking.vue?vue&type=template&id=7630042b&scoped=true"
import script from "./complaintTracking.vue?vue&type=script&lang=js"
export * from "./complaintTracking.vue?vue&type=script&lang=js"

import "./complaintTracking.vue?vue&type=style&index=0&id=7630042b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7630042b"]])

export default __exports__